@layer design-system {
  .root {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .gapSm {
    row-gap: 4px;

    --grid-gap: 4px;
  }

  .gapMd {
    row-gap: 8px;

    --grid-gap: 8px;
  }

  .gapLg {
    row-gap: 12px;

    --grid-gap: 12px;
  }
}
